query ChartOfAccounts {
  chartOfAccounts(orderBy: NAME_ASC) {
    nodes {
      id
      name
      corporateChartOfAccountId
    }
  }
}
